/**
 * Browser-safe request context store.
 * On the server, AsyncLocalStorage registers its getter via registerGetStore().
 * On the browser, getRequestContext() always returns undefined (unused by apiClientBrowser).
 */
interface RequestContextStore {
  origin: string;
  hostname: string;
  languageCode: string | undefined;
}

type GetStoreFn = () => RequestContextStore | undefined;

let getStoreFn: GetStoreFn = () => undefined;

export const registerGetStore = (fn: GetStoreFn): void => {
  getStoreFn = fn;
};

export const getRequestContext = (): RequestContextStore | undefined => getStoreFn();
